import React from "react";
import { useTranslation } from "react-i18next";
import { useRemoveComment } from "@planzone/view-models";
import { Modal } from "@common/modal";
import { Button } from "@common/button";
import { RichTextInput } from "@common/richTextInput";
import { Props } from "./types";
import styles from "./styles.scss";

function CommentRemoval({ comment, cancel }: Props) {
  const { t } = useTranslation();
  const { isRequestPending, removeComment } = useRemoveComment(comment);

  return (
    <Modal
      header={t("removeComment.title")}
      className={styles.commentRemoval}
      headerClassName={styles.header}
      close={cancel}
    >
      <div className={styles.main}>
        <div className={styles.group}>
          <p className={styles.subTitle}>{t("removeComment.description")} :</p>
          <RichTextInput value={comment.content} isDisabled input={() => {}} />
        </div>
        <div className={styles.buttons}>
          <Button type="cancel" press={cancel}>
            {t("removeComment.cancel")}
          </Button>
          <Button
            type="delete"
            status={isRequestPending ? "pending" : "none"}
            press={() => removeComment(comment)}
          >
            {t("removeComment.confirm")}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export { CommentRemoval };
